import React from 'react'

import type { RatingStarProps } from '@/types/components/buying-panel/rating-star'

export const RatingStar: React.FC<RatingStarProps> = ({ type }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none">
    <>
      {type === 'half' && (
        <path
          fill="currentColor"
          d="m4.223 12.854 3.527-2.562V2L6.403 6.146h-4.36L5.57 8.708l-1.347 4.146Z"
        />
      )}
      <path
        fill={type === 'full' ? 'currentColor' : 'transparent'}
        stroke="currentColor"
        d="m7.75 2 1.347 4.146h4.36L9.93 8.708l1.347 4.146-3.527-2.562-3.527 2.562L5.57 8.708 2.044 6.146h4.359L7.75 2Z"
      ></path>
    </>
  </svg>
)
